// components/TenantActionsMenu.tsx
import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Box
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import { Client } from '../../apis/tenantApi/tenantApi';

interface Props {
  tenant: Client;
}

const TenantActionsMenu: React.FC<Props> = ({ tenant }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    handleClose();
    navigate(`/tenants/view/${tenant.clientId}`);
  };

  const handlePermissions = () => {
    handleClose();
    navigate(`/tenants/permissions/${tenant.clientId}`);
  };

  const handlePostProvision = () => {
    handleClose();
    navigate(
      `/tenants/configure/${tenant.clientId}?name=${tenant.clientName}`
    );
  };

  return (
    <Box>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleView}>View</MenuItem>
        <MenuItem onClick={handlePermissions}>Permissions</MenuItem>
        <MenuItem onClick={handlePostProvision}>Post Provision</MenuItem>
      </Menu>
    </Box>
  );
};

export default TenantActionsMenu;
